// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hero-hero-rR1Kd {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),
    radial-gradient(circle at 8% 95%, #e4f6f3, transparent 45%), #fff;
  padding: 64px 0 56px;
  color: #0f1214;
  color: var(--ink);
}

.Hero-wrap-MrJV6 {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 48px;
}

.Hero-copy-lySTA {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  min-width: 0;
}

.Hero-eyebrow-wslg1 {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 16px;
}

.Hero-h1-DPX43 {
  font-size: clamp(32px, 5.4vw, 52px);
  line-height: 1.06;
  font-weight: 800;
  margin: 0 0 18px;
}

.Hero-sub-qvizO {
  font-size: clamp(16px, 2.2vw, 20px);
  color: var(--muted);
  max-width: 560px;
  margin: 0 0 28px;
  line-height: 1.55;
}

.Hero-ctas-cBjLO {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 22px;
}

.Hero-btnPrimary-YRLa5,
.Hero-btnSecondary-t0hYh {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 16px;
  text-decoration: none;
  -webkit-transition: background 0.16s, border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, background 0.16s, border-color 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, background 0.16s, border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.Hero-btnPrimary-YRLa5 {
  background: var(--red);
  color: #fff;
}

.Hero-btnPrimary-YRLa5:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  -webkit-box-shadow: 0 14px 30px rgba(232, 35, 43, 0.28);
          box-shadow: 0 14px 30px rgba(232, 35, 43, 0.28);
}

.Hero-btnSecondary-t0hYh {
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
}

.Hero-btnSecondary-t0hYh:hover {
  border-color: #f3c9cb;
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.Hero-badges-m5GIY {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px 18px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.Hero-badge-LYhre {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}

.Hero-badgeCheck-Ql8RL {
  width: 18px;
  height: 18px;
  color: var(--green);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.Hero-art-qamfl {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 360px;
  max-width: 42%;
}

.Hero-art-qamfl svg {
  width: 100%;
  height: auto;
}

@media (max-width: 880px) {
  .Hero-wrap-MrJV6 {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    text-align: center;
    gap: 32px;
  }
  .Hero-sub-qvizO {
    margin-left: auto;
    margin-right: auto;
  }
  .Hero-ctas-cBjLO,
  .Hero-badges-m5GIY {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }
  .Hero-art-qamfl {
    width: 280px;
    max-width: 80%;
  }
}

@media (max-width: 680px) {
  .Hero-hero-rR1Kd {
    padding: 44px 0 40px;
  }
}

@media (prefers-color-scheme: dark) {
  .Hero-hero-rR1Kd {
    background: radial-gradient(circle at 85% 12%, rgba(232, 35, 43, 0.12), transparent 45%),
      radial-gradient(circle at 8% 95%, rgba(22, 163, 74, 0.12), transparent 45%), #14171a;
    color: #f3f4f6;
  }
  .Hero-h1-DPX43 {
    color: #f3f4f6;
  }
  .Hero-sub-qvizO,
  .Hero-badge-LYhre {
    color: #9aa3ad;
  }
  .Hero-btnSecondary-t0hYh {
    background: #1d2125;
    color: #f3f4f6;
    border-color: #2c3137;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/marketing/Hero.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF;qEACmE;EACnE,oBAAoB;EACpB,cAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAW;MAAX,aAAW;UAAX,SAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2GAAmF;EAAnF,mGAAmF;EAAnF,mFAAmF;EAAnF,sIAAmF;AACrF;;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,uDAA+C;UAA/C,+CAA+C;AACjD;;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AACA;EACE,qBAAqB;EACrB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAEE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,cAAc;EAChB;AACF;;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE;0FACsF;IACtF,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;AACF","sourcesContent":[".hero {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),\n    radial-gradient(circle at 8% 95%, #e4f6f3, transparent 45%), #fff;\n  padding: 64px 0 56px;\n  color: var(--ink);\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  gap: 48px;\n}\n\n.copy {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 16px;\n}\n\n.h1 {\n  font-size: clamp(32px, 5.4vw, 52px);\n  line-height: 1.06;\n  font-weight: 800;\n  margin: 0 0 18px;\n}\n\n.sub {\n  font-size: clamp(16px, 2.2vw, 20px);\n  color: var(--muted);\n  max-width: 560px;\n  margin: 0 0 28px;\n  line-height: 1.55;\n}\n\n.ctas {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-bottom: 22px;\n}\n\n.btnPrimary,\n.btnSecondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  font-weight: 700;\n  font-size: 16px;\n  text-decoration: none;\n  transition: transform 0.16s, box-shadow 0.16s, background 0.16s, border-color 0.16s;\n}\n.btnPrimary {\n  background: var(--red);\n  color: #fff;\n}\n.btnPrimary:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n  box-shadow: 0 14px 30px rgba(232, 35, 43, 0.28);\n}\n.btnSecondary {\n  background: #fff;\n  color: var(--ink);\n  border: 1px solid var(--line);\n}\n.btnSecondary:hover {\n  border-color: #f3c9cb;\n  transform: translateY(-2px);\n}\n\n.badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 18px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--muted);\n}\n.badgeCheck {\n  width: 18px;\n  height: 18px;\n  color: var(--green);\n  flex: 0 0 auto;\n}\n\n.art {\n  flex: 0 0 auto;\n  width: 360px;\n  max-width: 42%;\n}\n.art svg {\n  width: 100%;\n  height: auto;\n}\n\n@media (max-width: 880px) {\n  .wrap {\n    flex-direction: column;\n    text-align: center;\n    gap: 32px;\n  }\n  .sub {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .ctas,\n  .badges {\n    justify-content: center;\n  }\n  .art {\n    width: 280px;\n    max-width: 80%;\n  }\n}\n@media (max-width: 680px) {\n  .hero {\n    padding: 44px 0 40px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .hero {\n    background: radial-gradient(circle at 85% 12%, rgba(232, 35, 43, 0.12), transparent 45%),\n      radial-gradient(circle at 8% 95%, rgba(22, 163, 74, 0.12), transparent 45%), #14171a;\n    color: #f3f4f6;\n  }\n  .h1 {\n    color: #f3f4f6;\n  }\n  .sub,\n  .badge {\n    color: #9aa3ad;\n  }\n  .btnSecondary {\n    background: #1d2125;\n    color: #f3f4f6;\n    border-color: #2c3137;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `Hero-hero-rR1Kd`,
	"wrap": `Hero-wrap-MrJV6`,
	"copy": `Hero-copy-lySTA`,
	"eyebrow": `Hero-eyebrow-wslg1`,
	"h1": `Hero-h1-DPX43`,
	"sub": `Hero-sub-qvizO`,
	"ctas": `Hero-ctas-cBjLO`,
	"btnPrimary": `Hero-btnPrimary-YRLa5`,
	"btnSecondary": `Hero-btnSecondary-t0hYh`,
	"badges": `Hero-badges-m5GIY`,
	"badge": `Hero-badge-LYhre`,
	"badgeCheck": `Hero-badgeCheck-Ql8RL`,
	"art": `Hero-art-qamfl`
};
module.exports = ___CSS_LOADER_EXPORT___;
